export default __webpack_public_path__ + "static/media/2268.5ab432dd.png";